import MembersSectionOne from "./MembershipSection/MemberSectionOne";

export default function Membership () {
    return (
        <div className="">
            <MembersSectionOne />
        </div>
    )
}